import React, { PropsWithChildren } from 'react';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import CalendarRange from '@app/state/calendar/CalendarRange';
import ParityFilterInput from '@app/model/parity/input/ParityFilterInput';
import { useQuery } from '@tanstack/react-query';
import ParityService from '@app/model/parity/service/ParityService';
import { ParityQueryKeys } from '@app/model/parity/service/ParityQueryKeys';
import { OtaPriceStateSnapshot } from '@app/model/parity/OtaPriceStateSnapshot';

export const OtaPricesForPeriodContext = React.createContext<OtaPriceStateSnapshot | undefined>(undefined);

const OtaPricesForPeriodProvider: React.FunctionComponent<PropsWithChildren<{
	companyHotel: CompanyHotel,
	range: CalendarRange,
	parityFilter: ParityFilterInput
}>> = ({ companyHotel, range, parityFilter, children }) => {

	const otaPricesQuery = useQuery({
		queryFn: () => ParityService.findOtaPricesForPeriod(companyHotel.id, range.startStatDate, range.endStatDate, parityFilter),
		queryKey: ParityQueryKeys.ota_periods(companyHotel.id, range.startStatDate, range.endStatDate, parityFilter),
		refetchOnWindowFocus: false,
	});

	if (otaPricesQuery.isSuccess) {
		return <OtaPricesForPeriodContext.Provider
			value={otaPricesQuery.data}>{children}</OtaPricesForPeriodContext.Provider>;

	} else return <></>;
};

export default OtaPricesForPeriodProvider;